<template>
  <div :class="_.grid">
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
      <template v-else-if="theme.titleType === 'text'">
        <div :class="_.title" :style="{ color: theme.titleFontColor }">
          {{ theme.title }}
        </div>
      </template>
    </div>

    <!-- mode === 'image'，image为纯图片模式，textImage为图文模式 -->
    <div
      v-if="theme.mode === 'textImage'"
      :class="_.bd"
      :style="{
        'padding-top': $transformPx(theme.paddingTop),
        'padding-left': $transformPx(theme.paddingBoth),
        'padding-right': $transformPx(theme.paddingBoth),
      }"
    >
      <div
        v-for="(item, index) in data"
        :key="item.id"
        v-track="{
          name: '商品宫格-商品',
          id: `DianJiZiDingYiYeZiYuan`,
          resource: item,
          index: index,
          extra: getTrackExtra(item, index),
        }"
        :class="_.textItem"
        :style="{
          'border-color': theme.borderColor,
        }"
        @click="$dmbcResourceClick(item)"
      >
        <img :src="item.icon" :class="_.cover" />
        <div :class="_.text">
          <div :class="_.title">{{ item.title }}</div>
          <div :class="_.price"><span>￥</span>{{ item.discountAmt }}</div>
        </div>
      </div>
    </div>

    <div
      v-else
      :class="_.bd"
      :style="{
        'padding-top': $transformPx(theme.paddingTop),
        'padding-left': $transformPx(theme.paddingBoth),
        'padding-right': $transformPx(theme.paddingBoth),
      }"
    >
      <div
        v-for="(item, index) in data"
        :key="item.id"
        v-track="{
          name: '商品宫格-商品',
          id: `DianJiZiDingYiYeZiYuan`,
          resource: item,
          index: index,
          extra: getTrackExtra(item, index),
        }"
        :class="_.item"
        @click="$dmbcResourceClick(item)"
      >
        <img :src="item.icon" :class="_.cover" />
      </div>
    </div>

    <img
      v-if="theme.showMore"
      :src="theme.moreBtnConfig.image"
      :class="_.more"
      :style="{
        width: $transformPx(theme.moreBtnConfig.width),
      }"
      @click="$dmbcResourceClick(theme.moreBtnConfig.routeUrl)"
    />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .grid {
    border-radius: var(--border-radius);
    padding: 16px 12px;
    font-size: 0;

    .hd {
      margin-bottom: 16px;
      .image {
        width: 100%;
        height: auto;
      }

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 25px;
        text-align: center;
      }
    }

    .bd {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 8px;
      gap: 8px;

      .item {
        width: 100%;
        max-height: 128px;
        border-radius: 8px;
        overflow: hidden;

        .cover {
          width: 100%;
          height: 100%;
          border-radius: 8px;
          object-fit: cover;
        }
      }

      .textItem {
        box-sizing: border-box;
        width: 100%;
        height: 186px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #fcd29c;

        .cover {
          width: 100%;
          height: 110px;
          object-fit: cover;
          vertical-align: middle;
        }
        .text {
          box-sizing: border-box;
          height: 76px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 6px;
          .title {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            // line-height: 20px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .price {
            font-size: 16px;
            font-weight: bold;
            color: #ff111c;
            line-height: 16px;

            span {
              font-size: 11px;
            }
          }
        }
      }
    }
    .more {
      display: block;
      margin: 0 auto;
      margin-top: 12px;
      width: 250px;
    }
  }
</style>
